import {layoutMarkup} from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";

export const dividerSection = (param, is_public = false) => {
    param.class = param.class ? param.class : 'editor-section';
    param.content = param.content ? param.content : '';
    param.style = param.style ? param.style : '';
    param.section = 'dividerSection';
    param.component = `<hr class="editor-divider">`;
    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}
